import { useTranslations } from 'next-intl';

import CrossIcon from '@/fo/icons/base/icons/cross24.svg';
import { CategoryButton } from '@/fo/ui/category/button/base';
import { NavButton } from '@/fo/ui/category/carousel/base';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';

import { CategoryChip } from '../components/CategoryChip/CategoryChip';

import { styles } from './UiCategoryCarouselChip.styles';

export interface UiCategoryCarouselChipProps {
  items: CategoryButton[];
  onClick?: (id?: string) => void;
  onReset: () => void;
}

export function UiCategoryCarouselChip({
  items,
  onClick,
  onReset
}: UiCategoryCarouselChipProps) {
  const slots = styles();
  const t = useTranslations();

  const handleClick = (id?: string) => {
    onClick?.(id);
  };

  const handleReset = () => {
    onReset?.();
  };

  const hasReset = items.some((item) => item.active);

  return (
    <div className={slots.base()}>
      <UiKitCarouselBase
        className={slots.carousel()}
        viewportClassName={slots.viewport()}
        loop={false}
        showArrows={false}
        dragFree
        renderCustomControls={(controls) => (
          <div className={slots.controls()}>
            <div className={slots.controlsContainer()}>
              <div className={slots.controlsInner()}>
                <NavButton
                  disabled={controls.prevBtnDisabled}
                  onClick={controls.onPrevButtonClick}
                  className={slots.controlsButton()}
                />
                <NavButton
                  disabled={controls.nextBtnDisabled}
                  direction="next"
                  onClick={controls.onNextButtonClick}
                  className={slots.controlsButton()}
                />
              </div>
            </div>
          </div>
        )}
      >
        {hasReset && (
          <UiKitButtonBase
            className={slots.resetButton()}
            color="ghost"
            onClick={handleReset}
          >
            <span>{t('reset')}</span>
            <CrossIcon className={slots.resetButtonIcon()} />
          </UiKitButtonBase>
        )}
        {items
          .filter((item) => item.active)
          .map((item) => (
            <CategoryChip
              key={item.id}
              category={item}
              onClick={handleClick}
            />
          ))}
        {items
          .filter((item) => !item.active)
          .map((item) => (
            <CategoryChip
              key={item.id}
              category={item}
              onClick={handleClick}
            />
          ))}
      </UiKitCarouselBase>
    </div>
  );
}
